const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
const API_KEY = process.env.REACT_APP_API_KEY;

export const storeCypher = async (cypher, expirationTime) => {
  try {
    const response = await fetch(`${API_BASE_URL}/store-cypher`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(API_KEY ? { "X-API-Key": API_KEY } : {}),
      },
      body: JSON.stringify({ cypher, expiration_time: expirationTime }),
    });

    const payload = await response.json().catch(() => null);
    if (!response.ok || !payload) {
      return {
        success: false,
        message:
          payload?.message ||
          payload?.detail ||
          `API error (${response.status})`,
        data: null,
      };
    }

    return payload;
  } catch (error) {
    return { success: false, message: "Network error", data: null };
  }
};

export const retrieveCypher = async (cypherUuid) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/retrieve-cypher/${cypherUuid}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(API_KEY ? { "X-API-Key": API_KEY } : {}),
        },
      }
    );

    const payload = await response.json().catch(() => null);
    if (!response.ok || !payload) {
      return {
        success: false,
        message:
          payload?.message ||
          payload?.detail ||
          `API error (${response.status})`,
        data: null,
      };
    }

    return payload;
  } catch (error) {
    return { success: false, message: "Network error", data: null };
  }
};
